const themes = {
  BlackGlass: {
    '--b1': '#1f2937',
    '--b2': '#374151',
    '--b3': '#4b5563',
    '--bc': '#ffffff',
    '--p': '#374151',
    '--pf': '#4b5563',
    '--pc': '#ffffff',
    '--s': '#6b7280',
    '--sf': '#9ca3af',
    '--sc': '#ffffff',
    '--n': '#374151',
    '--nf': '#4b5563',
    '--nc': '#ffffff',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },
   
  ModernLight: {
    '--b1': '#ffffff',
    '--b2': '#f5f6fa',
    '--b3': '#e6e8ed',
    '--bc': '#1f2937',
    '--p': '#2563eb',
    '--pf': '#1d4ed8',
    '--pc': '#ffffff',
    '--s': '#6b7280',
    '--sf': '#4b5563',
    '--sc': '#ffffff',
    '--n': '#d1d5db',
    '--nf': '#9ca3af',
    '--nc': '#1f2937',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },

  SkyBlue: {
    '--b1': '#ecf5ff',
    '--b2': '#ffffff',
    '--b3': '#dbeafe',
    '--bc': '#1e3a8a',
    '--p': '#3b82f6',
    '--pf': '#2563eb',
    '--pc': '#ffffff',
    '--s': '#60a5fa',
    '--sf': '#3b82f6',
    '--sc': '#ffffff',
    '--n': '#93c5fd',
    '--nf': '#60a5fa',
    '--nc': '#1e3a8a',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },

  EmeraldSoft: {
    '--b1': '#e9fdf4',
    '--b2': '#ffffff',
    '--b3': '#d1fae5',
    '--bc': '#064e3b',
    '--p': '#10b981',
    '--pf': '#059669',
    '--pc': '#ffffff',
    '--s': '#34d399',
    '--sf': '#10b981',
    '--sc': '#ffffff',
    '--n': '#6ee7b7',
    '--nf': '#34d399',
    '--nc': '#064e3b',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },

  GlassMorphic: {
    '--b1': 'rgba(255,255,255,0.15)',
    '--b2': 'rgba(255,255,255,0.25)',
    '--b3': 'rgba(255,255,255,0.35)',
    '--bc': '#ffffff',
    '--p': 'rgba(255,255,255,0.35)',
    '--pf': 'rgba(255,255,255,0.45)',
    '--pc': '#ffffff',
    '--s': 'rgba(0,0,0,0.15)',
    '--sf': 'rgba(0,0,0,0.25)',
    '--sc': '#ffffff',
    '--n': 'rgba(255,255,255,0.18)',
    '--nf': 'rgba(255,255,255,0.28)',
    '--nc': '#ffffff',
    '--rounded-box': '1rem',
    '--rounded-btn': '0.5rem',
  },

  SlateGray: {
    '--b1': '#f3f4f6',
    '--b2': '#ffffff',
    '--b3': '#e5e7eb',
    '--bc': '#0f172a',
    '--p': '#475569',
    '--pf': '#334155',
    '--pc': '#ffffff',
    '--s': '#64748b',
    '--sf': '#475569',
    '--sc': '#ffffff',
    '--n': '#cbd5e1',
    '--nf': '#94a3b8',
    '--nc': '#0f172a',
    '--rounded-box': '0.35rem',
    '--rounded-btn': '0.25rem',
  },

  Glass: {
    '--b1': 'rgba(255,255,255,0.1)',
    '--b2': 'rgba(255,255,255,0.2)',
    '--b3': 'rgba(255,255,255,0.3)',
    '--bc': '#1f2937',
    '--p': 'rgba(255,255,255,0.2)',
    '--pf': 'rgba(255,255,255,0.3)',
    '--pc': '#1f2937',
    '--s': 'rgba(0,0,0,0.1)',
    '--sf': 'rgba(0,0,0,0.2)',
    '--sc': '#1f2937',
    '--n': 'rgba(255,255,255,0.1)',
    '--nf': 'rgba(255,255,255,0.2)',
    '--nc': '#1f2937',
    '--rounded-box': '1rem',
    '--rounded-btn': '0.5rem',
  },
  Metropolis: {
    '--b1': '#f3f4f6',
    '--b2': '#ffffff',
    '--b3': '#e5e7eb',
    '--bc': '#1f2937',
    '--p': '#374151',
    '--pf': '#4b5563',
    '--pc': '#ffffff',
    '--s': '#6b7280',
    '--sf': '#9ca3af',
    '--sc': '#ffffff',
    '--n': '#d1d5db',
    '--nf': '#9ca3af',
    '--nc': '#1f2937',
    '--rounded-box': '0.25rem',
    '--rounded-btn': '0.125rem',
  },
 MetropolisBlue : {
    '--b1': '#dbeafe',
    '--b2': '#ffffff',
    '--b3': '#bfdbfe',
    '--bc': '#1e3a8a',
    '--p': '#2563eb',
    '--pf': '#1d4ed8',
    '--pc': '#ffffff',
    '--s': '#3b82f6',
    '--sf': '#2563eb',
    '--sc': '#ffffff',
    '--n': '#93c5fd',
    '--nf': '#60a5fa',
    '--nc': '#1e3a8a',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },
  Office2003Olive: {
    '--b1': '#ecfdf5',
    '--b2': '#ffffff',
    '--b3': '#d1fae5',
    '--bc': '#064e3b',
    '--p': '#16a34a',
    '--pf': '#15803d',
    '--pc': '#ffffff',
    '--s': '#22c55e',
    '--sf': '#16a34a',
    '--sc': '#ffffff',
    '--n': '#86efac',
    '--nf': '#4ade80',
    '--nc': '#064e3b',
    '--rounded-box': '0.375rem',
    '--rounded-btn': '0.25rem',
  },
  Light: {
    '--b1': '#ffffff',
    '--b2': '#f9fafb',
    '--b3': '#f3f4f6',
    '--bc': '#111827',
    '--p': '#3b82f6',
    '--pf': '#2563eb',
    '--pc': '#ffffff',
    '--s': '#6b7280',
    '--sf': '#4b5563',
    '--sc': '#ffffff',
    '--n': '#e5e7eb',
    '--nf': '#d1d5db',
    '--nc': '#111827',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },
  Dark: {
    '--b1': '#1f2937',
    '--b2': '#374151',
    '--b3': '#4b5563',
    '--bc': '#ffffff',
    '--p': '#4b5563',
    '--pf': '#6b7280',
    '--pc': '#ffffff',
    '--s': '#9ca3af',
    '--sf': '#d1d5db',
    '--sc': '#1f2937',
    '--n': '#374151',
    '--nf': '#4b5563',
    '--nc': '#ffffff',
    '--rounded-box': '0.5rem',
    '--rounded-btn': '0.25rem',
  },
  Cupcake: {
    '--b1': '#fdf2f8',
    '--b2': '#fce7f3',
    '--b3': '#f9a8d4',
    '--bc': '#831843',
    '--p': '#ec4899',
    '--pf': '#db2777',
    '--pc': '#ffffff',
    '--s': '#f472b6',
    '--sf': '#ec4899',
    '--sc': '#ffffff',
    '--n': '#be185d',
    '--nf': '#db2777',
    '--nc': '#ffffff',
    '--rounded-box': '1rem',
    '--rounded-btn': '0.5rem',
  },
  HighContrastLight: {
    '--b1': '#ffffff',
    '--b2': '#f8f9fa',
    '--b3': '#e9ecef',
    '--bc': '#000000',
    '--p': '#000000',
    '--pf': '#333333',
    '--pc': '#ffffff',
    '--s': '#000000',
    '--sf': '#333333',
    '--sc': '#ffffff',
    '--n': '#000000',
    '--nf': '#333333',
    '--nc': '#ffffff',
    '--rounded-box': '0.25rem',
    '--rounded-btn': '0.125rem',
  },
  EnterpriseOlive: {
  '--b1': '#ffffff',
  '--b2': '#f8faf8',
  '--b3': '#edf7ed',
  '--bc': '#1f2937',
  '--p': '#4d7c0f',
  '--pf': '#3f6212',
  '--pc': '#ffffff',
  '--s': '#6b7280',
  '--sf': '#4b5563',
  '--sc': '#ffffff',
  '--n': '#d9eecb',
  '--nf': '#b8db99',
  '--nc': '#1f2937',
  '--rounded-box': '0.4rem',
  '--rounded-btn': '0.25rem',
},
PurpleRoyal: {
  '--b1': '#f8f5ff',
  '--b2': '#ede9fe',
  '--b3': '#ddd6fe',
  '--bc': '#3b0764',
  '--p': '#7c3aed',
  '--pf': '#6d28d9',
  '--pc': '#ffffff',
  '--s': '#a78bfa',
  '--sf': '#8b5cf6',
  '--sc': '#ffffff',
  '--n': '#c4b5fd',
  '--nf': '#a78bfa',
  '--nc': '#3b0764',
  '--rounded-box': '0.5rem',
  '--rounded-btn': '0.25rem',
},

PurpleLight: {
  '--b1': '#fcfbff',
  '--b2': '#f5f3ff',
  '--b3': '#ede9fe',
  '--bc': '#312e81',
  '--p': '#8b5cf6',
  '--pf': '#7c3aed',
  '--pc': '#ffffff',
  '--s': '#c4b5fd',
  '--sf': '#a78bfa',
  '--sc': '#312e81',
  '--n': '#ddd6fe',
  '--nf': '#c4b5fd',
  '--nc': '#312e81',
  '--rounded-box': '0.5rem',
  '--rounded-btn': '0.25rem',
},

PurpleDark: {
  '--b1': '#1e1b2e',
  '--b2': '#312e4d',
  '--b3': '#43365f',
  '--bc': '#ffffff',
  '--p': '#8b5cf6',
  '--pf': '#7c3aed',
  '--pc': '#ffffff',
  '--s': '#a78bfa',
  '--sf': '#c4b5fd',
  '--sc': '#ffffff',
  '--n': '#4c3d68',
  '--nf': '#5b4b7a',
  '--nc': '#ffffff',
  '--rounded-box': '0.5rem',
  '--rounded-btn': '0.25rem',
},

Lavender: {
  '--b1': '#faf5ff',
  '--b2': '#f3e8ff',
  '--b3': '#e9d5ff',
  '--bc': '#581c87',
  '--p': '#a855f7',
  '--pf': '#9333ea',
  '--pc': '#ffffff',
  '--s': '#c084fc',
  '--sf': '#a855f7',
  '--sc': '#ffffff',
  '--n': '#d8b4fe',
  '--nf': '#c084fc',
  '--nc': '#581c87',
  '--rounded-box': '0.75rem',
  '--rounded-btn': '0.4rem',
},

Amethyst: {
  '--b1': '#f7f2ff',
  '--b2': '#ede4ff',
  '--b3': '#dccbff',
  '--bc': '#4c1d95',
  '--p': '#9333ea',
  '--pf': '#7e22ce',
  '--pc': '#ffffff',
  '--s': '#a855f7',
  '--sf': '#9333ea',
  '--sc': '#ffffff',
  '--n': '#c4b5fd',
  '--nf': '#a78bfa',
  '--nc': '#4c1d95',
  '--rounded-box': '0.6rem',
  '--rounded-btn': '0.3rem',
},

CorporatePurple: {
  '--b1': '#ffffff',
  '--b2': '#f8f7fc',
  '--b3': '#efebff',
  '--bc': '#312e81',
  '--p': '#6d28d9',
  '--pf': '#5b21b6',
  '--pc': '#ffffff',
  '--s': '#8b5cf6',
  '--sf': '#7c3aed',
  '--sc': '#ffffff',
  '--n': '#ddd6fe',
  '--nf': '#c4b5fd',
  '--nc': '#312e81',
  '--rounded-box': '0.35rem',
  '--rounded-btn': '0.25rem',
},

GlassPurple: {
  '--b1': 'rgba(124,58,237,0.12)',
  '--b2': 'rgba(124,58,237,0.18)',
  '--b3': 'rgba(124,58,237,0.28)',
  '--bc': '#ffffff',
  '--p': 'rgba(139,92,246,0.35)',
  '--pf': 'rgba(109,40,217,0.45)',
  '--pc': '#ffffff',
  '--s': 'rgba(196,181,253,0.35)',
  '--sf': 'rgba(167,139,250,0.45)',
  '--sc': '#ffffff',
  '--n': 'rgba(255,255,255,0.18)',
  '--nf': 'rgba(255,255,255,0.28)',
  '--nc': '#ffffff',
  '--rounded-box': '1rem',
  '--rounded-btn': '0.5rem',
},

DeepViolet: {
  '--b1': '#140f2d',
  '--b2': '#231942',
  '--b3': '#312e81',
  '--bc': '#ffffff',
  '--p': '#7c3aed',
  '--pf': '#6d28d9',
  '--pc': '#ffffff',
  '--s': '#a78bfa',
  '--sf': '#c4b5fd',
  '--sc': '#ffffff',
  '--n': '#4338ca',
  '--nf': '#6366f1',
  '--nc': '#ffffff',
  '--rounded-box': '0.5rem',
  '--rounded-btn': '0.25rem',
},
  MinimalWhite: {
  '--b1': '#ffffff',
  '--b2': '#f8fafc',
  '--b3': '#edf2f7',
  '--bc': '#1a202c',
  '--p': '#3182ce',
  '--pf': '#2b6cb0',
  '--pc': '#ffffff',
  '--s': '#718096',
  '--sf': '#4a5568',
  '--sc': '#ffffff',
  '--n': '#e2e8f0',
  '--nf': '#cbd5e0',
  '--nc': '#1a202c',
  '--rounded-box': '0.4rem',
  '--rounded-btn': '0.25rem',
},

  FioriLight: {
  '--b1': '#ffffff',
  '--b2': '#f7f7f7',
  '--b3': '#ededed',
  '--bc': '#1f2937',
  '--p': '#0a6ed1',
  '--pf': '#085caf',
  '--pc': '#ffffff',
  '--s': '#6a6d70',
  '--sf': '#4b4d4f',
  '--sc': '#ffffff',
  '--n': '#d9d9d9',
  '--nf': '#bfbfbf',
  '--nc': '#1f2937',
  '--rounded-box': '0.3rem',
  '--rounded-btn': '0.2rem',
},

  FluentLight: {
  '--b1': '#ffffff',
  '--b2': '#fafafa',
  '--b3': '#f3f3f3',
  '--bc': '#2d2d2d',
  '--p': '#0078d4',
  '--pf': '#106ebe',
  '--pc': '#ffffff',
  '--s': '#5c5c5c',
  '--sf': '#404040',
  '--sc': '#ffffff',
  '--n': '#e5e5e5',
  '--nf': '#cfcfcf',
  '--nc': '#2d2d2d',
  '--rounded-box': '0.35rem',
  '--rounded-btn': '0.2rem',
},

 CorporateBlue: {
  '--b1': '#ffffff',
  '--b2': '#f3f6fb',
  '--b3': '#e5ecf7',
  '--bc': '#1e3a8a',
  '--p': '#2563eb',
  '--pf': '#1d4ed8',
  '--pc': '#ffffff',
  '--s': '#64748b',
  '--sf': '#475569',
  '--sc': '#ffffff',
  '--n': '#dbeafe',
  '--nf': '#bfdbfe',
  '--nc': '#1e3a8a',
  '--rounded-box': '0.4rem',
  '--rounded-btn': '0.25rem',
},

  HighContrastBlue: {
    '--b1': '#ffffff',
    '--b2': '#e6f3ff',
    '--b3': '#cce7ff',
    '--bc': '#003366',
    '--p':  '#003366',
    '--pf': '#002244',
    '--pc': '#ffffff',
    '--s':  '#003366',
    '--sf': '#002244',
    '--sc': '#ffffff',
    '--n': '#003366',
    '--nf': '#002244',
    '--nc': '#ffffff',
    '--rounded-box': '0.25rem',
    '--rounded-btn': '0.125rem',
  },
  HighContrastGreen: {
    '--b1': '#ffffff',
    '--b2': '#e6f7e6',
    '--b3': '#ccf2cc',
    '--bc': '#004d00',
    '--p': '#004d00',
    '--pf': '#003300',
    '--pc': '#ffffff',
    '--s': '#004d00',
    '--sf': '#003300',
    '--sc': '#ffffff',
    '--n': '#004d00',
    '--nf': '#003300',
    '--nc': '#ffffff',
    '--rounded-box': '0.25rem',
    '--rounded-btn': '0.125rem',
  },
};

export default themes;
